import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { generateTable } from '../../table/Table';
import { fetchBridgeModel } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('name', 'name').end(); // Handles bridge model api response by checking for error and also returning
// error if active mapping is not present. If valid returns object with the
// attributes and their mappings.

var handleBridgeModel = function handleBridgeModel(_ref) {
  var _ref$bridgeModel = _ref.bridgeModel,
      error = _ref$bridgeModel.error,
      attributes = _ref$bridgeModel.attributes,
      activeMappingName = _ref$bridgeModel.activeMappingName,
      mappings = _ref$bridgeModel.mappings;

  if (error) {
    return {
      error: error
    };
  }

  var mapping = mappings.find(function (_ref2) {
    var name = _ref2.name;
    return name === activeMappingName;
  });

  if (!mapping) {
    return {
      error: 'Invalid bridge model, active mapping not found'
    };
  }

  return {
    attributes: attributes,
    attributeMappings: mapping.attributes
  };
};

var transform = function transform(_ref3) {
  var attributes = _ref3.attributes,
      attributeMappings = _ref3.attributeMappings;
  return {
    data: attributes.map(function (attribute) {
      var mapping = attributeMappings.find(function (_ref4) {
        var name = _ref4.name;
        return name === attribute.name;
      });
      return _objectSpread(_objectSpread({}, attribute), {}, {
        structureField: mapping ? mapping.structureField || '' : null
      });
    })
  };
};

var dataSource = function dataSource(_ref5) {
  var modelName = _ref5.modelName;
  return {
    fn: function fn() {
      return fetchBridgeModel({
        modelName: modelName
      }).then(handleBridgeModel);
    },
    clientSide: clientSide,
    params: function params() {
      return [{
        modelName: modelName
      }];
    },
    transform: transform
  };
}; // const filters = () => () => [{ name: 'name', label: 'Name', type: 'text' }];


var columns = [{
  value: 'name',
  title: 'Name',
  sortable: true
}, {
  value: 'structureField',
  title: 'Mapping',
  type: 'text'
}];
export var BridgeModelAttributeTable = generateTable({
  columns: columns,
  // filters,
  dataSource: dataSource,
  tableOptions: ['modelName']
});
BridgeModelAttributeTable.displayName = 'BridgeModelAttributeTable';